import classNames from 'classnames';
import styles from './AppUsage.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { ProgressBar } from '@/components/ProgressBar';
import { formatPercent } from '@/utils/numberUtils';
import { classifyAppByProductivity } from '@/utils/productivityAppClassifier';
import { InitialsBadge } from '@/components/InitialsBadge';
import { CategoryTagComponent as CategoryTag } from './components/CategoryTag.component';

export const appUsageTableConfig = ({
  sessionTotalSeconds = 0,
  focusApps = [],
  distractionApps = [],
} = {}) => {
  return [
    {
      id: 'no',
      name: '#',
      sortable: false,
      cellRenderer: (row, rowIndex) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
            className={styles.numberCell}
          >
            {rowIndex + 1}
          </Text>
        );
      },
    },
    {
      id: 'applicationName',
      name: 'APPLICATION',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div className={styles.applicationCell}>
            <InitialsBadge label={row.appName} />
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Medium}
              className={styles.appNameCell}
            >
              {row.appName}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'category',
      name: 'CATEGORY',
      sortable: false,
      cellRenderer: (row) => {
        const category = classifyAppByProductivity(row.appName, {
          focusApps,
          distractionApps,
        });
        return <CategoryTag category={category} />;
      },
    },
    {
      id: 'timeSpent',
      name: 'TIME SPENT',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <Text
            variant={textVariantsEnum.Text_13}
            fontWeight={fontWeightEnum.Medium}
            className={styles.timeSpentCell}
          >
            {row.formattedTime}
          </Text>
        );
      },
    },
    {
      id: 'percentOfTime',
      name: '% OF TIME',
      sortable: false,
      cellRenderer: (row) => {
        const percent = sessionTotalSeconds
          ? (row.seconds / sessionTotalSeconds) * 100
          : 0;
        return (
          <div className={classNames(styles.percentCell)}>
            <ProgressBar percent={percent} color="blue-500" />
            <Text
              variant={textVariantsEnum.Text_13}
              fontWeight={fontWeightEnum.Medium}
              className={styles.percentValue}
            >
              {formatPercent(percent)}
            </Text>
          </div>
        );
      },
    },
  ];
};
